import { GetSetSuperArgsFunction, IsFactoryClass, MakeFactory } from '../../../../classes/class-helpers/factory';
import { DistinctValueObservableFactory, } from '../sync/implementation';
import { BaseClass } from '../../../../classes/class-helpers/base-class';
import { IS_OBSERVABLE_LIKE_CONSTRUCTOR } from '../../../../core/observable/constructor';
import { ObservableFactory } from '../../../../core/observable/implementation';
import { IsDistinctValueObservableConstructor } from '../sync/constructor';
import { DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE } from './privates';
import { ConstructAsyncDistinctValueObservable, IS_ASYNC_VALUE_OBSERVABLE_CONSTRUCTOR } from './constructor';
export function AsyncDistinctValueObservableOnObserved(instance, observer) {
    instance[DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE].onObserveHook(observer);
}
export function AsyncDistinctValueObservableOnUnobserved(instance, observer) {
    instance[DISTINCT_ASYNC_VALUE_OBSERVABLE_PRIVATE].onUnobserveHook(observer);
}
function PureAsyncDistinctValueObservableFactory(superClass) {
    if (!IsDistinctValueObservableConstructor(superClass)) {
        throw new TypeError(`Expected DistinctValueObservables' constructor as superClass`);
    }
    const setSuperArgs = GetSetSuperArgsFunction(IsFactoryClass(superClass));
    return class AsyncDistinctValueObservable extends superClass {
        constructor(...args) {
            const [create] = args[0];
            let context;
            super(...setSuperArgs(args.slice(1), [
                (_context) => {
                    context = _context;
                    return {
                        onObserved: (observer) => {
                            AsyncDistinctValueObservableOnObserved(this, observer);
                        },
                        onUnobserved: (observer) => {
                            AsyncDistinctValueObservableOnUnobserved(this, observer);
                        }
                    };
                }
            ]));
            ConstructAsyncDistinctValueObservable(this, context, create);
        }
    };
}
export let AsyncDistinctValueObservable;
export function AsyncDistinctValueObservableFactory(superClass) {
    return MakeFactory(PureAsyncDistinctValueObservableFactory, [], superClass, {
        name: 'AsyncDistinctValueObservable',
        instanceOf: AsyncDistinctValueObservable,
        waterMarks: [IS_ASYNC_VALUE_OBSERVABLE_CONSTRUCTOR, IS_OBSERVABLE_LIKE_CONSTRUCTOR],
    });
}
export function AsyncDistinctValueObservableBaseFactory(superClass) {
    return MakeFactory(PureAsyncDistinctValueObservableFactory, [DistinctValueObservableFactory, ObservableFactory], superClass, {
        name: 'AsyncDistinctValueObservable',
        instanceOf: AsyncDistinctValueObservable,
        waterMarks: [IS_ASYNC_VALUE_OBSERVABLE_CONSTRUCTOR, IS_OBSERVABLE_LIKE_CONSTRUCTOR],
    });
}
AsyncDistinctValueObservable = class AsyncDistinctValueObservable extends AsyncDistinctValueObservableBaseFactory(BaseClass) {
    constructor(create) {
        super([create], [], []);
    }
};
//# sourceMappingURL=implementation.js.map